import * as THREE from 'three';

// Generation works in Unreal-style centimetres with Z up (x, y ground plane).
// Rendering uses metres with Y up. The mapping keeps a top-down view (looking along -Y) with
// +x right and generation +y pointing "up" the screen (three -z), so CCW stays CCW.
export const CM_TO_M = 0.01;

export function genToThree(x: number, y: number, z: number, out = new THREE.Vector3()): THREE.Vector3 {
  return out.set(x * CM_TO_M, z * CM_TO_M, -y * CM_TO_M);
}

export function threeToGen(v: THREE.Vector3): { x: number; y: number; z: number } {
  return { x: v.x / CM_TO_M, y: -v.z / CM_TO_M, z: v.y / CM_TO_M };
}

/** Convert an interleaved gen-space xyz Float32Array (cm, Z up) to three space in place. */
export function convertPositionsInPlace(a: Float32Array): Float32Array {
  for (let i = 0; i < a.length; i += 3) {
    const x = a[i];
    const y = a[i + 1];
    const z = a[i + 2];
    a[i] = x * CM_TO_M;
    a[i + 1] = z * CM_TO_M;
    a[i + 2] = -y * CM_TO_M;
  }
  return a;
}

/** Normals: same axis swap, no scale. */
export function convertNormalsInPlace(a: Float32Array): Float32Array {
  for (let i = 0; i < a.length; i += 3) {
    const x = a[i];
    const y = a[i + 1];
    const z = a[i + 2];
    a[i] = x;
    a[i + 1] = z;
    a[i + 2] = -y;
  }
  return a;
}
